import React from "react";
import { TrendingUp, TrendingDown } from "lucide-react";

const ticks = [
  { name: "EURUSD", price: "1.1612", change: 0.12 },
  { name: "GBPUSD", price: "1.3402", change: -0.08 },
  { name: "USDJPY", price: "158.54", change: 0.05 },
  { name: "Gold", price: "4554.41", change: 0.92 },
  { name: "Silver", price: "78.28", change: -0.34 },
  { name: "Bitcoin", price: "80,570", change: 1.84 },
  { name: "Ethereum", price: "2,256.70", change: -0.45 },
  { name: "DJ30", price: "49,685", change: 0.21 },
  { name: "NAS100", price: "29,146", change: 0.66 },
  { name: "Tesla", price: "279.87", change: -1.15 },
  { name: "Apple", price: "192.46", change: 0.38 },
  { name: "Oil", price: "104.16", change: 0.55 },
];

const Pill = ({ t }) => {
  const up = t.change >= 0;
  return (
    <div className="flex items-center gap-2 px-4 py-2 mx-1.5 rounded-full border border-white/8 bg-white/[0.02] whitespace-nowrap">
      <span className="text-white text-[13px] font-medium">{t.name}</span>
      <span className="text-white/70 text-[12px] tabular-nums">{t.price}</span>
      <span
        className={`flex items-center gap-0.5 text-[11px] font-medium tabular-nums ${
          up ? "text-emerald-400" : "text-rose-400"
        }`}
      >
        {up ? <TrendingUp size={11} /> : <TrendingDown size={11} />}
        {up ? "+" : ""}
        {t.change}%
      </span>
    </div>
  );
};

const Ticker = () => {
  const items = [...ticks, ...ticks];
  return (
    <div className="border-y border-white/5 bg-[#08090f] overflow-hidden py-3">
      <div className="flex animate-marquee w-max">
        {items.map((t, i) => (
          <Pill key={i} t={t} />
        ))}
      </div>
    </div>
  );
};

export default Ticker;
